import "../../assets/css/results/navigation.css"
import { useGeneralStates } from "../../context/general-context"
import { ACTIONS, RESULTS_SECTIONS } from "../../utils/globalUtils"

export default function Navigation({ navigationVisibility }) {
    const { state, dispatch, showSubscribeModal, triggerDetailsSection } = useGeneralStates()
    
    function handleSelectSection(e) {
        const { id } = e.target

        triggerDetailsSection()
        dispatch({ type: ACTIONS.setResultsSection, payload: RESULTS_SECTIONS[id] })
    }

    return (
        <section className={`navigationContainer ${navigationVisibility}`}>
            <button 
                id={RESULTS_SECTIONS.edit} 
                className={`navButton ${state.resultsSection === RESULTS_SECTIONS.edit ? "selected" : ""}`} 
                onClick={showSubscribeModal}
            >
                Edit mode
            </button>
            
            <button 
                id={RESULTS_SECTIONS.map} 
                className={`navButton ${state.resultsSection === RESULTS_SECTIONS.map ? "selected" : ""}`} 
                onClick={handleSelectSection}
            >
                Map view
            </button>
            
            <button 
                id={RESULTS_SECTIONS.wants} 
                className={`navButton ${state.resultsSection === RESULTS_SECTIONS.wants ? "selected" : ""}`} 
                onClick={handleSelectSection}
            >
                Wants view
            </button>
        </section>
    )
}
